import React 				from 'react';
import PropTypes			from 'prop-types';


const Popup = ({className = '', zIndex = null, style = {}, onClick = ()=>{}, btn=()=>(''), title = 'Title', showTitle = true, children, active = true, close = true}) => {
	const paddingInnerTop = showTitle ? '' : 'padding--bottom_10';

	if (!active ) return (<React.Fragment>{children} </React.Fragment>);

	const zIndexStyle = zIndex ? {zIndex} : {};

	return (
		<React.Fragment>
			<div className="popup" style={zIndexStyle}>
				<div className={`popup__inner ${className}`}>
					{
						showTitle ? (
							<div className="popup-title flex--row_center-between">

								<div className="popup-title--text bold--standart" style = {style}>{title}</div>

								<span className="flex--row_center-between">
									{btn()}
									{close ? <div className="close" onClick={() => {onClick()}}></div> : null}
								</span>
							</div>
						) : (
							<div className={paddingInnerTop}>
								<div className="popup-title--text bold--standart" style = {style} onClick={() =>{onClick()}}></div>
							</div>
						)
					}

					{children}
				</div>
			</div>
		</React.Fragment>
	)
};

Popup.propTypes = {
	className: PropTypes.string,
	zIndex: PropTypes.string,
	style: PropTypes.object,
	onClick: PropTypes.func,
	btn: PropTypes.func,
	title: PropTypes.string,
	showTitle: PropTypes.bool,
	active: PropTypes.bool,
	close: PropTypes.bool,
	children: PropTypes.oneOfType([ PropTypes.arrayOf(PropTypes.node), PropTypes.node ]).isRequired,
};

export default Popup;
